import React from "react";
import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions, MaterialIcon } from "@loanbossinc/component-library";

import {
  shouldShowReplacementPer_Per,
  shouldShowRepairPerId_Per,
  REPAIR_COMPLETION_DEADLINE,
  CAPEX_COMPLETION_DEADLINE
} from "./section-loan-escrow-reserve-rows-logic";

const dragComponent = <MaterialIcon iconName="drag_indicator" />;
export const rows = data => ({
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Escrow/Reserve",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.header"
      }
    ]
  },
  taxReserve: {
    label: "Tax Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.taxReserve",
        hideLabel: true,
        label: "Yes",
        altlabel: "No"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.taxReserve"
      }
    ]
  },
  insuranceReserve: {
    label: "Insurance Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.insuranceReserve",
        hideLabel: true,
        label: "Yes",
        altlabel: "No"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.insuranceReserve"
      }
    ]
  },
  taxInsuranceReserve: {
    label: "Tax and Insurance Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.taxInsuranceReserve",
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.taxInsuranceReserve"
      }
    ]
  },
  taxInsuranceReserveAccount: {
    label: "Tax and Insurance Reserve Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.taxInsuranceReserveAccount",
        hideLabel: true,
        label: "Account",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.taxInsuranceReserveAccount"
      }
    ]
  },
  replacementReserve: {
    label: "Replacement Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.replacementReserve",
        variant: "filled",
        decimals: 2
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Per",
        isVisible: data => shouldShowReplacementPer_Per(data.covenants)
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "replacementPer",
        name: "covenants.replacementPerId",
        variant: "filled",
        parentId: "propertySizes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        },
        style: { marginLeft: "10px", width: "185px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.replacementReserve"
      }
    ]
  },
  replacementReserveAccount: {
    label: "Replacement Reserve Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.replacementReserveAccount",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.replacementReserveAccount"
      }
    ]
  },
  repairReserve: {
    label: "Repair Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.repairReserve",
        hideLabel: true,
        variant: "filled",
        decimals: 2
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Per",
        isVisible: data => shouldShowRepairPerId_Per(data.covenants)
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "repairPerId",
        name: "covenants.repairPerId",
        variant: "filled",
        parentId: "propertySizes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        },
        style: { marginLeft: "10px", width: "185px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.repairReserve"
      }
    ]
  },
  repairReserveAccount: {
    label: "Repair Reserve Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.repairReserveAccount",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.repairReserveAccount"
      }
    ]
  },
  addrepairCompletionDeadline: {
    key: "addDeadline",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "REPAIR COMPLETION DEADLINE"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        label: "Add Deadline",
        hideLabel: true,
        size: ButtonSizeOptions.lgFluid,
        onClick: (value, formik) => {
          let { details } = formik.values;
          if (!details) {
            details = { id: "new", repairCompletionDeadline: [] };
          }
          if (details && !details.repairCompletionDeadline) {
            details.repairCompletionDeadline = [];
          }

          const sortOrder =
              formik.values.details && formik.values.details.repairCompletionDeadline ? formik.values.details.repairCompletionDeadline.length + 1 : 1;
          const newrepairCompletionDeadlineRow = {
            id: "new",
            loanId: details.id,
            type: REPAIR_COMPLETION_DEADLINE,
            name: null,
            dueDate: null,
            sortOrder
          };

          if (!formik.values.details || !formik.values.details.repairCompletionDeadline) {
            details.repairCompletionDeadline.push(newrepairCompletionDeadlineRow);
          } else {
            details.repairCompletionDeadline.splice(formik.values.details.repairCompletionDeadline.length, 0, newrepairCompletionDeadlineRow);
          }

          formik.setValues({ ...formik.values, details });
        },
        style: { width: "142px", marginTop: "10px", float: "right" }
      }
    ]
  },
  repairCompletionDeadline: {
    hasNestedRows: true,
    isDragable: true,
    key: "details.repairCompletionDeadline",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TEXT,
              value: dragComponent,
              style: { marginLeft: 0 }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              name: `details.repairCompletionDeadline[${index}].completed`,
              label: "Repairs complete"
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Deadline",
              hasBorder: false,
              size: ButtonSizeOptions.smFluid,
              name: `details.repairCompletionDeadline[${index}].id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                const { details } = formik.values;
                let loanloanDeadlines = formik.values.details.repairCompletionDeadline;
                if (value !== null) {
                  loanloanDeadlines = loanloanDeadlines.filter(loanloanDeadlines => loanloanDeadlines.id !== value);
                } else {
                  loanloanDeadlines.splice(index, 1);
                }
                details.repairCompletionDeadline = loanloanDeadlines;
                formik.setValues({ ...formik.values, details });
              },
              style: { width: "132px", marginTop: "10px", float: "right" }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.STRING,
              label: "Deadline Name",
              name: `details.repairCompletionDeadline[${index}].name`,
              variant: "filled",
              decimals: 2,
              style: { marginTop: "10px", marginBottom: "16px", marginLeft: "0" },
              isDisabled: data => data.details.repairCompletionDeadline[index].completed
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.DATE,
              name: `details.repairCompletionDeadline[${index}].dueDate`,
              hideLabel: true,
              variant: "filled",
              isDisabled: data => data.details.repairCompletionDeadline[index].completed
            })
          }
        ]
      }
    ]
  },
  tilcReserves: {
    label: "TILC Reserves",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.tilcReserves",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.tilcReserves"
      }
    ]
  },

  tilcReservesMisc: {
    label: "TILC Reserves Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.tilcReservesMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.tilcReservesMisc"
      }
    ]
  },
  goodNewsMoneyDeadline: {
    label: "Good News Money Deadline",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.goodNewsMoneyDeadline",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      }
    ]
  },
  goodNewsMoneyDrawn: {
    label: "Good News Money Drawn",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.goodNewsMoneyDrawn",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.goodNewsMoneyDrawn"
      }
    ]
  },
  ffeReserve: {
    label: "FF&E Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.ffeReserve",
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.ffeReserve"
      }
    ]
  },
  ffeReserveAccount: {
    label: "FF&E Reserve Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.ffeReserveAccount",
        hideLabel: true,
        label: "Account",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.ffeReserveAccount"
      }
    ]
  },
  capExReserves: {
    label: "Cap Ex Reserves",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.capExReserves",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.capExReserves"
      }
    ]
  },
  capExReservesMisc: {
    label: "Cap Ex Reserves Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.capExReservesMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.capExReservesMisc"
      }
    ]
  },
  addcapExCompletionDeadline: {
    key: "addDeadline",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "CAPEX DEADLINE"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        label: "Add Deadline",
        hideLabel: true,
        size: ButtonSizeOptions.lgFluid,
        onClick: (value, formik) => {
          let { details } = formik.values;
          if (!details) {
            details = { id: "new", capExCompletionDeadline: [] };
          }
          if (details && !details.capExCompletionDeadline) {
            details.capExCompletionDeadline = [];
          }

          const sortOrder =
              formik.values.details && formik.values.details.capExCompletionDeadline ? formik.values.details.capExCompletionDeadline.length + 1 : 1;
          const newcapExCompletionDeadlineRow = {
            id: "new",
            loanId: details.id,
            type: CAPEX_COMPLETION_DEADLINE,
            name: null,
            dueDate: null,
            sortOrder
          };

          if (!formik.values.details || !formik.values.details.capExCompletionDeadline) {
            details.capExCompletionDeadline.push(newcapExCompletionDeadlineRow);
          } else {
            details.capExCompletionDeadline.splice(formik.values.details.capExCompletionDeadline.length, 0, newcapExCompletionDeadlineRow);
          }

          formik.setValues({ ...formik.values, details });
        },
        style: { width: "142px", marginTop: "10px", float: "right" }
      }
    ]
  },
  capExCompletionDeadline: {
    hasNestedRows: true,
    isDragable: true,
    key: "details.capExCompletionDeadline",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TEXT,
              value: <MaterialIcon iconName="drag_indicator" />,
              style: { marginLeft: 0 }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              name: `details.capExCompletionDeadline[${index}].completed`,
              label: "Repairs complete"
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Deadline",
              hasBorder: false,
              size: ButtonSizeOptions.smFluid,
              name: `details.capExCompletionDeadline[${index}].id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                const { details } = formik.values;
                let loanloanDeadlines = formik.values.details.capExCompletionDeadline;
                if (value !== null) {
                  loanloanDeadlines = loanloanDeadlines.filter(loanloanDeadlines => loanloanDeadlines.id !== value);
                } else {
                  loanloanDeadlines = loanloanDeadlines.splice(index, 1);
                }
                details.capExCompletionDeadline = loanloanDeadlines;
                formik.setValues({ ...formik.values, details });
              }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.STRING,
              label: "Deadline Name",
              name: `details.capExCompletionDeadline[${index}].name`,
              variant: "filled",
              decimals: 2,
              style: { marginTop: "10px", marginBottom: "16px", marginLeft: "0" },
              isDisabled: data => data.details.capExCompletionDeadline[index].completed
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.DATE,
              name: `details.capExCompletionDeadline[${index}].dueDate`,
              hideLabel: true,
              variant: "filled",
              isDisabled: data => data.details.capExCompletionDeadline[index].completed
            })
          }
        ]
      }
    ]
  },
  capExReservesDrawn: {
    label: "Cap Ex Reserves Drawn",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.capExReservesDrawn",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.capExReservesDrawn"
      }
    ]
  },
  shortfallReserve: {
    label: "Debt Service/Interest Shortfall Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.shortfallReserve",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.shortfallReserve"
      }
    ]
  },
  shortfallReserveMisc: {
    label: "Debt Service/Interest Shortfall Reserve Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.shortfallReserveMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.shortfallReserveMisc"
      }
    ]
  },
  operatingAccount: {
    label: "Operating Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.operatingAccount",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.operatingAccount"
      }
    ]
  },
  interestRateCapReserve: {
    label: "Interest Rate Cap Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.interestRateCapReserve",
        hideLabel: true,
        variant: "filled",
        multiline: true,
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.interestRateCapReserve"
      }
    ]
  },
  interestRateCapReserveMisc: {
    label: "Interest Rate Cap Reserve Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.interestRateCapReserveMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.interestRateCapReserveMisc"
      }
    ]
  },
  interestReserve: {
    label: "Interest Reserve",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.interestReserve",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.interestReserve"
      }
    ]
  },
  interestReserveMisc: {
    label: "Interest Reserve Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.interestReserveMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.interestReserveMisc"
      }
    ]
  },
  minCashDeposit: {
    label: "Min Cash Deposit",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "covenants.minCashDeposit",
        hideLabel: true,
        variant: "filled",
        decimals: 0
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.minCashDeposit"
      }
    ]
  },
  miscReserves: {
    label: "Reserves Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.escrowAccountsMisc",
        hideLabel: true,
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.escrowAccountsMisc"
      }
    ]
  }
});
